import {useCallback} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

import {getHrefWithQueryParams} from '../../../routes'
import type {TabId} from '../../../types'
import {isValue} from '../../../utils/guards'
import {queryToObject} from '../../../utils/queryParams'
import {Problems} from '../../packages/Problems/Problems.types'

export const useInvestigationTab = () => {
  const location = useLocation()
  const {investigationsTab} = queryToObject(location.search)
  const navigate = useNavigate()

  const onSelect = useCallback(
    (tab: TabId) => {
      navigate(
        getHrefWithQueryParams(location, null, _ => ({
          investigationsTab: tab,
        })),
      )
    },
    [location, navigate],
  )

  return {
    investigationsTab: isValue(Problems, investigationsTab) ? investigationsTab : Problems.TESTS,
    onSelect,
  }
}
